import { useState } from 'react';

export default function Works() {
  const [selectedWork, setSelectedWork] = useState<number | null>(null);

  const works = [
    {
      id: 1,
      title: '大淵直り山線歩道整備工事',
      image: 'https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/25d88b47bcd4e4fc2478881747294173.jpeg',
      description: '安全で快適な歩行空間を確保するための歩道整備工事を実施しています。',
      details: '大淵直り山線における歩道整備工事として、地域住民の安全な通行を確保するための整備を行っています。歩道の拡幅、段差の解消、適切な排水設備の設置など、バリアフリーに配慮した施工を実施。子どもからお年寄りまで、誰もが安心して歩ける快適な歩行空間の実現を目指しています。地域の皆様の安全を第一に考え、確実な施工を進めています。'
    },
    {
      id: 2,
      title: '両川用水路移設補償第2次工事',
      image: 'https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/3cbff9184c172ad426e00f71a91a0934.jpeg',
      description: '農業用水路工を中心とした用水路移設工事を実施しています。',
      details: '両川用水路の移設補償工事として、農業用水路工を施工しています。地域の農業用水を安定的に供給するため、適切な水路の設計と施工を行っています。環境に配慮しながら、確実な工事を進めています。'
    },
    {
      id: 4,
      title: '江建第19号-主要地方道新潟小杉三条線(舞潟地内)舗装修繕工事',
      image: 'https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/7e69d1b2475602548e6e961e00a977f4.jpeg',
      description: '主要地方道の舗装修繕工事を高品質で実施しています。',
      details: '主要地方道新潟小杉三条線の舞潟地内における舗装修繕工事を実施しています。道路の劣化部分を適切に修繕し、安全で快適な走行環境を確保します。路面の平坦性を高め、排水性能を向上させることで、雨天時でも安全な通行を実現。地域の重要な交通インフラとして、確実な施工品質を提供しています。長年の経験と技術力を活かし、耐久性の高い舗装工事を行っています。'
    },
    {
      id: 5,
      title: '一般県道沢海酒屋線(割野地内)防草対策工事',
      image: 'https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/5f475bd7532ad0a9a33f6f5ef6ff1bdb.jpeg',
      description: '道路の維持管理を目的とした防草対策工事を実施しています。',
      details: '一般県道沢海酒屋線の割野地内における防草対策工事を実施しています。道路の視認性と安全性を確保するため、適切な防草処理を行っています。雑草の繁茂を抑制することで、道路標識や路面標示の視認性を向上させ、安全な交通環境を維持します。環境に配慮した施工方法を採用し、長期的な効果を実現。道路の適切な維持管理により、地域の交通安全に貢献しています。'
    },
    {
      id: 6,
      title: '亀田１－３６８号線道路改良工事',
      image: 'https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/c0f995e6315fff49b2bf1ccd23e8a866.jpeg',
      description: '地域の交通環境を改善する道路改良工事を実施しています。',
      details: '亀田１－３６８号線における道路改良工事を実施しています。道路の拡幅、線形改良、排水設備の整備など、総合的な道路改良を行っています。地域住民の利便性向上と安全な交通環境の確保を目指し、計画的な施工を進めています。路面の平坦性を確保し、適切な勾配と排水処理により、雨天時でも安全に通行できる道路を実現。地域の発展に貢献する重要なインフラ整備として、確実な品質管理のもと工事を実施しています。'
    },
    {
      id: 7,
      title: '曽野木排水区曽野木幹線387耐震化工事',
      image: 'https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/e1e394c774eb1cff0670971fbcb1ae1a.jpeg',
      description: '排水施設の耐震性向上を目的とした重要な基盤整備工事を実施しています。',
      details: '曽野木排水区における曽野木幹線387の耐震化工事を実施しています。地震災害時でも排水機能を確実に維持できるよう、既存施設の耐震補強と改修工事を行っています。高度な技術と確実な施工により、地域の防災機能を大幅に向上させる重要なインフラ整備です。将来の災害に備え、住民の安全と地域の防災力強化に貢献する工事として、厳格な品質管理のもと確実な施工を進めています。'
    },
    {
      id: 9,
      title: '泥潟農道土留工事',
      image: 'https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/b33796f338bfe34c4321665f5d250e1d.jpeg',
      description: '農道の安全性を確保するための土留工事を実施しています。',
      details: '泥潟地区における農道土留工事を実施しています。農道の法面を適切に保護し、崩落を防止するための土留構造物を設置しています。地域の農業活動を支える重要なインフラとして、確実な施工を行っています。適切な排水処理と強固な土留構造により、長期的な安全性を確保。農道の安定性を高め、農作業の効率化と安全性向上に貢献しています。地域の農業振興を支える重要な基盤整備として、丁寧な施工を心がけています。'
    },
    {
      id: 8,
      title: '民家の土間コンクリート工事',
      image: 'https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/69de4bee7e3e2229948a710ff09404eb.jpeg',
      description: '住宅の土間コンクリート打設工事を丁寧に施工しています。',
      details: '民家における土間コンクリート工事を実施しています。駐車スペースやアプローチなど、住宅の利便性を高める土間コンクリートの打設を行っています。適切な下地処理と配合設計により、ひび割れや沈下のない高品質な仕上がりを実現。平坦性と耐久性を確保し、長期にわたって快適にご使用いただける施工を心がけています。住宅の価値を高める確実な施工で、お客様の暮らしをサポートいたします。'
    },
    {
      id: 3,
      title: '除雪作業',
      image: 'https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/094ce373bff4c550aac7a24f30f4838e.jpeg',
      description: '冬季の除雪作業を迅速かつ確実に実施しています。',
      details: '新潟の厳しい冬に対応した除雪作業を行っています。道路、駐車場、施設周辺など、様々な場所の除雪に対応。24時間体制で迅速に対応し、安全な交通環境を確保します。最新の除雪機械を使用し、効率的な作業を実現しています。'
    }
  ];

  return (
    <>
      <section id="works" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <p className="text-teal-600 text-sm font-semibold mb-2 tracking-wider">WORKS</p>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">施工実績</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              長年の経験と確かな技術で、様々な工事を手掛けてきました。
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {works.map((work) => (
              <div
                key={work.id}
                className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedWork(work.id)}
              >
                <div className="relative w-full h-80 overflow-hidden">
                  <img
                    src={work.image}
                    alt={work.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500 brightness-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-2xl font-bold text-white mb-2">{work.title}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 mb-4">{work.description}</p>
                  <div className="flex items-center text-teal-600 font-semibold group-hover:translate-x-2 transition-transform">
                    詳細を見る
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedWork && (
        <div
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedWork(null)}
        >
          <div
            className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {works.map((work) => {
              if (work.id === selectedWork) {
                return (
                  <div key={work.id}>
                    <div className="relative w-full h-96">
                      <img
                        src={work.image}
                        alt={work.title}
                        className="w-full h-full object-cover object-top brightness-110"
                      />
                      <button
                        onClick={() => setSelectedWork(null)}
                        className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
                      >
                        <i className="ri-close-line text-2xl text-gray-900"></i>
                      </button>
                    </div>
                    <div className="p-8">
                      <h3 className="text-3xl font-bold text-gray-900 mb-4">{work.title}</h3>
                      <p className="text-gray-700 leading-relaxed">{work.details}</p>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      )}
    </>
  );
}
